export { BaseText, type BaseTextProps } from "./BaseText";
export { BodyText } from "./BodyText";
export { Bold } from "./Bold";
export { ChangeText, type ChangeTextProps } from "./ChangeText";
export { Colour, type ColourProps } from "./Colour";
export { Em } from "./Em";
export { NoRecords, type NoRecordsProps } from "./NoRecords";
export { Paragraphs, type ParagraphsProps } from "./Paragraphs";
export { Subtitle } from "./Subtitle";
export { Title } from "./Title";
